<!--
  Smart Grid Implementation of Table Load List Component

  This template will house the smart-grid component with column definitions,
  row expansion details template, and all necessary configurations.

  Reference: table-load-list.component.html
  PRD: docs/prd-generation/tasks/0001-prd-migrate-pedidos-table-to-smart-grid.md
-->

<div class="flex flex-auto flex-col overflow-auto mb-20">

  <!-- Search Input (conditional based on isSearch flag) -->
  <ng-container *ngIf="isSearch">
    <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64 w-80 my-1 mb-3" subscriptSizing="dynamic">
      <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
      <input matInput placeholder="Buscar" autocomplete="off" />
    </mat-form-field>
  </ng-container>

  <!-- Smart Grid Component -->
  <div class="container mt-0 flex-auto flex-col">
    <app-smart-grid
      [columnDefs]="ordersColumnDefs"
      [config]="ordersGridConfig"
      [data]="summaryData || []"
      [totalRecords]="totalItems"
      [detailTemplate]="rowDetailsTemplate"
      (pageChanged)="onPageChanged($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (rowExpansionChanged)="onRowExpansionChanged($event)">

      <!-- Expansion Detail Template - Copied from original component (lines 478-1516) -->
      <ng-template #rowDetailsTemplate let-order="row">
        <div class="flex border-b" *ngIf="!isFact">
          <form class="flex w-full flex-col">
            <div class="flex flex-col py-3 px-12 sm:flex-row">
              <div class="flex flex-auto flex-wrap gap-x-5">
                <div class="grid-container table-text" *ngIf="isAllColumnsMerma"></div>
                <div class="grid-container table-text" *ngIf="isAllColumnsMerma"></div>
                <div class="grid-container table-text" *ngIf="!isAllColumnsMerma">
                  <div class="row">
                    <div class="cell cell-3 table-title">Pagador:</div>
                    <div class="cell cell-4">
                      @if (order?.shipToType) {
                      <span [matTooltip]="order?.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                        style="cursor: pointer;">
                        <b>{{ order?.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b>
                      </span>
                      }
                      {{order?.soldTo?.externalKeys?.code + ' - '}} {{order?.soldTo?.name}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Destinatario:</div>
                    <div class="cell cell-4">
                      @if (order?.shipToType) {
                      <span [matTooltip]="order?.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                        style="cursor: pointer;">
                        <b>{{ order?.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b>
                      </span>
                      }
                      {{order?.shipTo?.externalKeys?.code + ' - '}} {{order?.shipTo?.name}}
                    </div>
                  </div>
                  @if (order?.shipToLegalCode) {
                  <div class="row">
                    <div class="cell cell-3 table-title">RTN:</div>
                    <div class="cell cell-4">{{ order?.shipToLegalCode }}</div>
                  </div>
                  }
                  <div class="row">
                    <div class="cell cell-3 table-title">Dirección:</div>
                    <div class="cell cell-4">
                      {{ order?.address?.address }}
                      {{
                      order?.address?.postalCode
                      ? " / " + order?.address?.postalCode
                      : " "
                      }}
                      {{
                      order?.address?.contactName
                      ? " / " + order?.address?.contactName
                      : " "
                      }}
                      {{
                      order?.address?.locationTwo?.name
                      ? " / " + order?.address?.locationTwo?.name
                      : " "
                      }}
                      {{
                      order?.address?.LocationThree?.name
                      ? " / " + order?.address?.LocationThree?.name
                      : " "
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Clase de Expedición:</div>
                    <div class="cell cell-4">
                      {{ order?.expeditionCondition?.externalKeys?.code }} -
                      {{ order?.expeditionCondition?.name }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Condición de Pago:</div>
                    <div class="cell cell-4">
                      {{ order?.paymentCondition?.externalKeys?.code }} -
                      {{ order?.paymentCondition?.name }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Observaciones:</div>
                    <div class="cell cell-4">
                      {{ order?.note ?? " - " }}
                    </div>
                  </div>
                  <div class="row"></div>
                </div>
                <div class="grid-container table-text" *ngIf="!isAllColumnsMerma">
                  <div class="row">
                    <div class="cell cell-3 table-title">Estado Global:</div>
                    <div class="cell cell-4">
                      {{
                      getExtraStatusName(order?.extraStatusERP, "GLOBAL")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Estado de rechazo:</div>
                    <div class="cell cell-4">
                      {{
                      getExtraStatusName(order?.extraStatusERP, "REJECT")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Estado de entrega:</div>
                    <div class="cell cell-4">
                      {{
                      getExtraStatusName(order?.extraStatusERP, "DELIVERY")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Estado de crédito:</div>
                    <div class="cell cell-4">
                      {{
                      getExtraStatusName(order?.extraStatusERP, "CREDIT")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Estado de factura:</div>
                    <div class="cell cell-4">
                      {{
                      getExtraStatusName(order?.extraStatusERP, "INVOICE")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Estado de usuario:</div>
                    <div class="cell cell-4">
                      {{ getExtraStatusName(order?.extraStatusERP, "USER") }}
                    </div>
                  </div>
                </div>
                <div class="grid-container table-text">
                  <div class="row">
                    <div class="cell cell-3 table-title">SubTotal:</div>
                    <div class="cell cell-4 text-right">
                      {{ order?.subTotal | decimalFormat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Recargo:</div>
                    <div class="cell cell-4 text-right">
                      {{ order?.totalSurcharges | decimalFormat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Descuento:</div>
                    <div class="cell cell-4 text-right">
                      {{ order?.totalDiscounts | decimalFormat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Impuesto:</div>
                    <div class="cell cell-4 text-right">
                      {{ order?.totalTaxes | decimalFormat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell cell-3 table-title">Total:</div>
                    <div class="cell cell-4 text-right">
                      {{ order?.total | decimalFormat }}
                    </div>
                  </div>
                </div>
                <div class="flex w-full flex-col">
                  <table class="min-w-500 overflow-y-visible mat-elevation-z mt-3" mat-table [dataSource]="getOrderDetails(order)"
                    matSort>
                    <ng-container matColumnDef="material">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                        <span style="margin-left: 5px">Material</span>
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                        <p class="table-text-m">
                          <span class="table-text-code" *ngIf="getCode(detail.material) as code" [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            {{ code }}
                          </span>
                          <span *ngIf="detail.statusId == 0" style="color: red"><b> (Eliminado)</b></span><br />
                          <span [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            {{ detail.material?.name }}
                          </span><br />
                          <span *ngIf="detail.returnType" [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            <b>MOTIVO:</b>{{ detail?.returnType?.name }}
                          </span>
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="note">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                        Nota
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                        <button mat-icon-button color="primary" (click)="openNoteDetail(order, detail)"
                          matTooltip="Ver nota" [disabled]="!(detail.note && detail.note != '')">
                          <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="warehouse">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                        Almacén
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                        <p *ngIf="!detail.isEditMode" class="table-text-m">
                          <span class="table-text-code" *ngIf="getCode(detail.warehouse) as code">
                            {{ code }} <br />
                          </span>
                          {{ detail.warehouse?.name }}
                        </p>
                        <mat-form-field *ngIf="detail.isEditMode" class="mt-2 w-full" appearance="fill" floatLabel="never">
                          <mat-select [(ngModel)]="detail.warehouse" placeholder="Almacén"
                            matTooltip="{{ detail.warehouse?.name }}" [ngModelOptions]="{ standalone: true }"
                            [compareWith]="compareById" (selectionChange)="
                              detail.thereIsChanges = true;
                              onChangeWarehouseInOrderDetail(detail)
                            ">
                            @for (
                            warehouse of order?.warehousesToUpdate || [];
                            track warehouse
                            ) {
                            <mat-option [value]="warehouse" class="text-content">
                              {{ warehouse.externalKeys?.code + " - "
                              }}{{ warehouse.name }}
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="soldQuantity">
                      <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle">
                        <span class="table-text-m-2 pd-l">Cantidad</span>
                      </th>

                      <td mat-cell *matCellDef="let detail" class="text-left first-col table-text">
                        <div class="flex items-start justify-between">
                          <div>
                            <p class="table-text-m-2 pd-l">
                              {{ detail?.soldQuantity | number: "1.3" }} ({{
                              detail?.soldUnitOfMeasure?.name
                              }}) <br />
                              <span class="f-9">
                                <b>UMB:</b>
                                {{ detail?.baseQuantity | number: "1.3" }} ({{
                                detail?.baseUnitOfMeasure?.name
                                }})<br />

                                <ng-container *ngIf="UMPActive">
                                  <b>UMP:</b>
                                  <ng-container *ngIf="detail?.pararellUnitOfMeasure; else noUMP">
                                    {{ detail?.pararellQuantity | number: "1.3" }} ({{
                                    detail?.pararellUnitOfMeasure?.name
                                    }})
                                  </ng-container>
                                </ng-container>
                                <ng-template #noUMP> - </ng-template>
                              </span>
                            </p>
                          </div>
                          <button *ngIf="batchesDetail && detail?.batches.length > 0" mat-icon-button color="primary"
                            (click)="openBatchesDetail(order, detail)" matTooltip="Ver lotes">
                            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="science"></mat-icon>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="unitPrice">
                      <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-center">
                        Precio
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-center">
                        @if (
                        detail.isEditMode &&
                        order?.class.canUpdatePrices == true
                        ) {
                        <mat-form-field class="mt-2" appearance="fill" floatLabel="never">
                          <input matInput type="number" [(ngModel)]="detail.unitPrice" placeholder="Precio"
                            [ngModelOptions]="{ standalone: true }" aria-label="Precio" matInput (change)="
                                onChangePriceInOrderDetail(order, detail)
                              " (keyup)="
                                onChangePriceInOrderDetail(order, detail)
                              " />
                        </mat-form-field>
                        } @else {
                        <span [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                          {{ detail?.unitPrice | decimalFormat }}
                        </span>
                        }
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="subTotal">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                        class="px-6 text-left first-col table-tittle">
                        SubTotal
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text text-right">
                        <span [style.textDecoration]="
                            detail.statusId == 0 ? 'line-through' : 'none'
                          " [style.textDecorationColor]="
                            detail.statusId == 0 ? 'red' : 'inherit'
                          ">
                          {{ detail?.subTotal | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="totalSurcharges">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                        class="px-6 text-left first-col table-tittle">
                        Recargo
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text text-right">
                        <span [style.textDecoration]="
                            detail.statusId == 0 ? 'line-through' : 'none'
                          " [style.textDecorationColor]="
                            detail.statusId == 0 ? 'red' : 'inherit'
                          ">
                          {{ detail?.totalSurcharges | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="totalDiscounts">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                        class="px-6 text-left first-col table-tittle">
                        Descuento
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text text-right">
                        <span [style.textDecoration]="
                            detail.statusId == 0 ? 'line-through' : 'none'
                          " [style.textDecorationColor]="
                            detail.statusId == 0 ? 'red' : 'inherit'
                          ">
                          {{ detail?.totalDiscounts | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="tax">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                        class="px-6 text-left first-col table-tittle">
                        Impuesto
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text text-right">
                        <span [style.textDecoration]="
                            detail.statusId == 0 ? 'line-through' : 'none'
                          " [style.textDecorationColor]="
                            detail.statusId == 0 ? 'red' : 'inherit'
                          ">
                          {{ detail?.totalTaxes | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="total">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                        class="px-6 text-left first-col table-tittle">
                        Total
                      </th>
                      <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text text-right">
                        <span [style.textDecoration]="
                            detail.statusId == 0 ? 'line-through' : 'none'
                          " [style.textDecorationColor]="
                            detail.statusId == 0 ? 'red' : 'inherit'
                          ">
                          {{ detail?.total | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
               
                    <!-- Header Row -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100 dark:bg-gray-900"></tr>
                    <!-- Fila principal -->
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail" class="border-b"></tr>
                  </table>
                </div>
              </div>
            </div>
          </form>
        </div>
        <mat-tab-group class="mr-auto"
                       [ngClass]="{
                         'max-w-[calc(100vw-350px)] 2xl:max-w-[calc(100vw-350px)]': isNavOpened,
                         'max-w-[calc(100vw-80px)] 2xl:max-w-[calc(100vw-80px)]': !isNavOpened
                       }" *ngIf="isFact">
          <mat-tab label="Detalles">
            <form class="flex w-full flex-col">
              <div class="flex flex-col py-3 px-12 sm:flex-row">
                <div class="flex flex-auto flex-wrap gap-x-5">
                  <div class="grid-container table-text">
                    <div class="row">
                      <div class="cell cell-3 table-title">Pagador:</div>
                      <div class="cell cell-4">
                        {{ order?.soldTo?.externalKeys?.code + " - " }}
                        {{ order?.soldTo?.name }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Destinatario:</div>
                      <div class="cell cell-4">
                        {{ order?.shipTo?.externalKeys?.code + " - " }}
                        {{ order?.shipTo?.name }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Dirección:</div>
                      <div class="cell cell-4">
                        {{ order?.address?.address }}
                        {{
                        order?.address?.postalCode
                        ? " / " + order?.address?.postalCode
                        : " "
                        }}
                        {{
                        order?.address?.contactName
                        ? " / " + order?.address?.contactName
                        : " "
                        }}
                        {{
                        order?.address?.locationTwo?.name
                        ? " / " + order?.address?.locationTwo?.name
                        : " "
                        }}
                        {{
                        order?.address?.LocationThree?.name
                        ? " / " + order?.address?.LocationThree?.name
                        : " "
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Clase de Expedición:</div>
                      <div class="cell cell-4">
                        {{ order?.expeditionCondition?.externalKeys?.code }} -
                        {{ order?.expeditionCondition?.name }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Condición de Pago:</div>
                      <div class="cell cell-4">
                        {{ order?.paymentCondition?.externalKeys?.code }} -
                        {{ order?.paymentCondition?.name }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Observaciones:</div>
                      <div class="cell cell-4">
                        {{ order?.note ?? " - " }}
                      </div>
                    </div>
                    <div class="row"></div>
                  </div>
                  <div class="grid-container table-text">
                    <div class="row">
                      <div class="cell cell-3 table-title">Estado Global:</div>
                      <div class="cell cell-4">
                        {{
                        getExtraStatusName(order?.extraStatusERP, "GLOBAL")
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Estado de rechazo:</div>
                      <div class="cell cell-4">
                        {{
                        getExtraStatusName(order?.extraStatusERP, "REJECT")
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Estado de entrega:</div>
                      <div class="cell cell-4">
                        {{
                        getExtraStatusName(
                        order?.extraStatusERP,
                        "DELIVERY"
                        )
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Estado de crédito:</div>
                      <div class="cell cell-4">
                        {{
                        getExtraStatusName(order?.extraStatusERP, "CREDIT")
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Estado de factura:</div>
                      <div class="cell cell-4">
                        {{
                        getExtraStatusName(order?.extraStatusERP, "INVOICE")
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Estado de usuario:</div>
                      <div class="cell cell-4">
                        {{
                        getExtraStatusName(order?.extraStatusERP, "USER")
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="grid-container table-text">
                    <div class="row">
                      <div class="cell cell-3 table-title">SubTotal:</div>
                      <div class="cell cell-4 text-right">
                        {{ order?.subTotal | decimalFormat }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Recargo:</div>
                      <div class="cell cell-4 text-right">
                        {{ order?.totalSurcharges | decimalFormat }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Descuento:</div>
                      <div class="cell cell-4 text-right">
                        {{ order?.totalDiscounts | decimalFormat }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Impuesto:</div>
                      <div class="cell cell-4 text-right">
                        {{ order?.totalTaxes | decimalFormat }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell cell-3 table-title">Total:</div>
                      <div class="cell cell-4 text-right">
                        {{ order?.total | decimalFormat }}
                      </div>
                    </div>
                  </div>
                  <div class="flex w-full flex-col">
                    <table class="min-w-500 overflow-y-visible mat-elevation-z mt-3" mat-table [dataSource]="getOrderDetails(order)"
                      matSort>
                      <ng-container matColumnDef="material">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                          <span style="margin-left: 5px">Material</span>
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <p class="table-text-m">
                            <span class="table-text-code" *ngIf="getCode(detail.material) as code" [style.textDecoration]="
                                detail.statusId == 0 ? 'line-through' : 'none'
                              " [style.textDecorationColor]="
                                detail.statusId == 0 ? 'red' : 'inherit'
                              ">
                              {{ code }}
                            </span>
                            <span *ngIf="detail.statusId == 0" style="color: red"><b> (Eliminado)</b></span><br />
                            <span [style.textDecoration]="
                                detail.statusId == 0 ? 'line-through' : 'none'
                              " [style.textDecorationColor]="
                                detail.statusId == 0 ? 'red' : 'inherit'
                              ">
                              {{ detail.material?.name }}
                            </span>
                          </p>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="note">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                          Nota
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <button mat-icon-button color="primary" matTooltip="Ver nota"
                            (click)="openNoteDetail(order, detail)" [disabled]="!(detail.note && detail.note !== '')">
                            <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="warehouse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                          Almacén
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <p *ngIf="!detail.isEditMode" class="table-text-m">
                            <span class="table-text-code" *ngIf="getCode(detail.warehouse) as code">
                              {{ code }} <br />
                            </span>
                            {{ detail.warehouse?.name }}
                          </p>
                          <mat-form-field *ngIf="detail.isEditMode" class="mt-2 w-full" appearance="fill" floatLabel="never">
                            <mat-select [(ngModel)]="detail.warehouse" placeholder="Almacén"
                              matTooltip="{{ detail.warehouse?.name }}" [ngModelOptions]="{ standalone: true }"
                              [compareWith]="compareById" (selectionChange)="
                                detail.thereIsChanges = true;
                                onChangeWarehouseInOrderDetail(detail)
                              ">
                              @for (
                              warehouse of order?.warehousesToUpdate || [];
                              track warehouse
                              ) {
                              <mat-option [value]="warehouse" class="text-content">
                                {{ warehouse.externalKeys?.code + " - "
                                }}{{ warehouse.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="soldQuantity">
                        <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle">
                          <span class="table-text-m-2 pd-l">Cantidad</span>
                        </th>
                        <td mat-cell *matCellDef="let detail" class="text-left first-col table-text">
                          <div class="flex items-start justify-between">
                  <div>
                      <p class="table-text-m-2 pd-l">
                        <app-unit-measure-display
                          [usedUnit]="{
                            quantity: detail?.soldQuantity,
                            unitId: detail?.soldUnitOfMeasure?._id,
                            unitName: detail?.soldUnitOfMeasure?.name,
                            unitAbbreviation: detail?.soldUnitOfMeasure?.code
                          }"
                          [baseUnit]="{
                            quantity: detail?.baseQuantity,
                            unitId: detail?.baseUnitOfMeasure?._id,
                            unitName: detail?.baseUnitOfMeasure?.name,
                            unitAbbreviation: detail?.baseUnitOfMeasure?.code
                          }"
                          [parallelUnit]="{
                            quantity: detail?.pararellQuantity,
                            unitId: detail?.pararellUnitOfMeasure?._id,
                            unitName: detail?.pararellUnitOfMeasure?.name,
                            unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                          }"
                          [material]="{
                            _id: detail?.material?._id,
                            code: detail?.material?.code,
                            UMPActive: detail?.material?.UMPActive
                          }"
                          [companyUMPActive]="UMPActive"
                          [statusId]="detail.statusId"
                        ></app-unit-measure-display>
                      </p>
                    </div>
                            <button *ngIf="batchesDetail && detail?.batches.length > 0" mat-icon-button color="primary"
                              (click)="openBatchesDetail(order, detail)" matTooltip="Ver lotes">
                              <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="science"></mat-icon>
                            </button>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="unitPrice">
                        <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-center">
                          Precio
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-center">
                          @if (
                          detail.isEditMode &&
                          order?.class.canUpdatePrices == true
                          ) {
                          <mat-form-field class="mt-2" appearance="fill" floatLabel="never">
                            <input matInput type="number" [(ngModel)]="detail.unitPrice" placeholder="Precio"
                              [ngModelOptions]="{ standalone: true }" aria-label="Precio" matInput (change)="
                                  onChangePriceInOrderDetail(order, detail)
                                " (keyup)="
                                  onChangePriceInOrderDetail(order, detail)
                                " />
                          </mat-form-field>
                          } @else {
                          <span [style.textDecoration]="
                                detail.statusId == 0 ? 'line-through' : 'none'
                              " [style.textDecorationColor]="
                                detail.statusId == 0 ? 'red' : 'inherit'
                              ">
                            {{ detail?.unitPrice | decimalFormat }}
                          </span>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="subTotal">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                          class="px-6 text-left first-col table-tittle">
                          SubTotal
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text text-right">
                          <span [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            {{ detail?.subTotal | decimalFormat }}
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="totalSurcharges">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                          class="px-6 text-left first-col table-tittle">
                          Recargo
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                          <span [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            {{ detail?.totalSurcharges | decimalFormat }}
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="totalDiscounts">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                          class="px-6 text-left first-col table-tittle">
                          Descuento
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 irst-col table-text text-right">
                          <span [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            {{ detail?.totalDiscounts | decimalFormat }}
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="tax">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                          class="px-6 text-left first-col table-tittle">
                          Impuesto
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                          <span [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            {{ detail?.totalTaxes | decimalFormat }}
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                          class="px-6 text-left first-col table-tittle">
                          Total
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                          <span [style.textDecoration]="
                              detail.statusId == 0 ? 'line-through' : 'none'
                            " [style.textDecorationColor]="
                              detail.statusId == 0 ? 'red' : 'inherit'
                            ">
                            {{ detail?.total | decimalFormat }}
                          </span>
                        </td>
                      </ng-container>

                      <!-- Header Row -->
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100 dark:bg-gray-900"></tr>
                      <!-- Fila principal -->
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail" class="border-b"></tr>
                    </table>
                  </div>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Métodos de Pago">
            <div class="p-4 overflow-x-auto">
              <table class="w-full min-w-[500px] mat-elevation-z mt-3" mat-table [dataSource]="getOrderPayments(order)">
                <ng-container matColumnDef="paymentMethod">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
                    Tipo Pago
                  </th>
                  <td mat-cell *matCellDef="let method" class="px-6 text-left first-col table-text">
                    <div class="flex items-center gap-2">
                      <span class="table-text-m">{{ method.paymentType?.name }}</span>
                      <button *ngIf="method.paymentType?.code === 'TP0006'  && method.originalPayments?.length > 0"
                        mat-icon-button (click)="openCreditNoteDetail(method)">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button *ngIf="method.paymentType?.code === 'TP00011'  && method.originalPayments?.length > 0"
                        mat-icon-button (click)="openCreditNoteDetail(method)">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button
                        *ngIf="method.originalPayments?.[0]?.paymentMethod?.code === 'MP00002'  && method.originalPayments?.length > 0"
                        mat-icon-button (click)="openCreditNoteDetail(method)">
                        <mat-icon>visibility</mat-icon>
                      </button>
                    </div>
                  </td>

                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="bank">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
                    Banco
                  </th>
                  <td mat-cell *matCellDef="let method" class="px-6 text-left first-col table-text">
                    {{ method?.bank?.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="operationNumber">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-center first-col table-tittle">
                    Cuenta
                  </th>
                  <td mat-cell *matCellDef="let method" class="px-6 text-center first-col table-text">
                    {{ method?.account?.accountNumber }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="overpayment">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-center first-col table-tittle">
                    Sobrepago({{ this.currency }})
                  </th>
                  <td mat-cell *matCellDef="let method" class="px-6 text-center first-col table-text">
                    {{ method?.totalOverPayment | moneda }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="px-6 text-center first-col font-bold">
                    {{this.totalOverPayment | moneda}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="paying">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle">
                    Abono ({{ this.currency }})
                  </th>
                  <td mat-cell *matCellDef="let method" class="px-6 text-right first-col table-text">
                    {{ method.totalPaying | moneda }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">
                    {{ this.totalPaying | moneda }}
                  </td>
                </ng-container>

                <!-- Fila de encabezado -->
                <tr mat-header-row *matHeaderRowDef="paymentMethodsDisplayedColumns" class="bg-gray-100 dark:bg-gray-900">
                </tr>

                <!-- Fila de footer -->
                <tr mat-footer-row *matFooterRowDef="paymentMethodsDisplayedColumns" class="border-gray-300"></tr>

                <!-- Filas de datos -->
                <tr mat-row *matRowDef="let row; columns: paymentMethodsDisplayedColumns" class="border-b h-12"></tr>

                <!-- Fila vacía si no hay datos -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell py-4 italic text-center" [colSpan]="paymentMethodsDisplayedColumns.length">
                    No hay métodos de pago registrados
                  </td>
                </tr>
              </table>
            </div>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </app-smart-grid>
  </div>

</div>

<ng-template #confirmDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{data?.title}}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p *ngIf="data?.message">{{data?.message}}</p>
        <div *ngIf="data?.innerHTML" [innerHTML]="data?.innerHTML"></div>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">
      Conservar
    </button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>
